export const contentType = "RebrandBlog";

export default (storyList = []) => {
	const list = storyList?.[contentType] || [];
	let categoriesMap = getBlogCategories(list);
	return {
		categoriesMap,
	};
};

export const getBlogCategories = (list) => {
	let categoriesMap = {};
	list?.forEach(({ full_slug: fullSlug }) => {
		const categories = fullSlug.split("/");
		const n = categories.length - 1;
		let filterSlug = categories[0];
		let slugHasRebrand = filterSlug === "rebrand";
		if (slugHasRebrand) {
			filterSlug += `/${categories[1]}`;
		}
		categories.forEach((type, categoryIndex) => {
			if (
				categoryIndex !== 0 &&
				categoryIndex !== n &&
				(!slugHasRebrand || categoryIndex !== 1)
			) {
				filterSlug += `/${type}`;
				if (!categoriesMap[type]) {
					categoriesMap[type] = {
						filterSlug,
					};
				}
			}
		});
	});
	return categoriesMap;
};
